<template>
  <Scaffold>
    <template #toolbar>
      <slot name="toolbar"></slot>
    </template>
    <template #bottombar>
      <slot name="bottombar"></slot>
    </template>
    <div class="centered" :class="{ horizontal, vertical }">
      <div>
        <div :style="{ width: width ? `${width}px` : undefined }">
          <slot></slot>
        </div>
      </div>
    </div>
  </Scaffold>
</template>

<style lang="scss" scoped>
.centered {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: auto;

  &.horizontal {
    align-items: center;
  }

  &.vertical {
    justify-content: center;
  }
}
</style>

<script>
import Scaffold from './Scaffold';

export default {
  components: {
    Scaffold
  },
  props: {
    width: {
      type: Number,
      default: undefined
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    vertical: {
      type: Boolean,
      default: true
    }
  }
};
</script>
